var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicCuerpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CCFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#99F6E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bodyGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D9488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#115E59"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(17, 94, 89, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8,18               L -8,12               C -8,12 -12,12 -14,10               C -16,8 -16,4 -11,0               C -8,-3 -6,-5 -6,-10               C -6,-12 -8,-13 -8,-15               C -8,-17 -6,-18 -4,-18               C -2,-18 -1,-16 -1,-13              C -1,-14 1,-16 3,-16              C 5,-16 6,-14 6,-11              C 6,-13 8,-15 10,-15              C 12,-15 13,-13 13,-9              C 13,-11 15,-12 16,-12              C 17,-12 18,-10 18,-6              C 18,-2 14,8 10,14              C 8,17 4,18 0,18              Z",
    fill: "url(#bodyGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3,1 C 3,-1 1,-3 -1,-3 C -3,-3 -5,-1 -5,1 C -5,3 -1,6 3,9 C 7,6 11,3 11,1 C 11,-1 9,-3 7,-3 C 5,-3 3,-1 3,1 Z",
    fill: "#F1F5F9",
    opacity: 0.9,
    transform: "scale(0.6) translate(3, 4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicCuerpo);
export default __webpack_public_path__ + "static/media/topic_cuerpo.fef7a77f552a5e8484ff74fa626d7bc7.svg";
export { ForwardRef as ReactComponent };